import { useMemo } from 'react';

import { useSelectedCanvasNodes } from '../useSelectedCanvasNodes';

export function useIsGroupSelection(): boolean {
  const selectedNodes = useSelectedCanvasNodes();

  return useMemo(() => {
    if (selectedNodes.length < 2) {
      return false;
    }

    const firstGroupId = selectedNodes[0]?.groupId;

    return !!firstGroupId && selectedNodes.every((n) => n.groupId === firstGroupId);
  }, [selectedNodes]);
}
